import { render, staticRenderFns } from "./AnswerError.vue?vue&type=template&id=72a0cc10&scoped=true&"
import script from "./AnswerError.vue?vue&type=script&lang=js&"
export * from "./AnswerError.vue?vue&type=script&lang=js&"
import style0 from "./AnswerError.vue?vue&type=style&index=0&id=72a0cc10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a0cc10",
  null
  
)

export default component.exports